<ng-container *ngFor="let icons of buttonIcon; let a = index">
  <!-- Regular button -->
  <button [ngClass]="icons.class"
          class="btn btn-icon btn-sm animate__animated animate__backInRight"
          [nbTooltip]="icons.title" (click)="processOption(icons)" type="button">
    <i [ngClass]="icons.icon"></i>
  </button>
</ng-container>

